import { Alert } from "interfaces/alert";
import { CellProps, Column } from "react-table";
import { DateWithTooltip } from "components/DateWithTooltip";
import { AvatarCell } from "components/SharedTable/tableRenderers";
import { AlertOccurrenceActioned } from "interfaces/alert";
import { convertActionToString } from "components/AlertsManagement/Archived/convertActionToString";

export interface ArchivedAlertTableColumnsProps {
  alertsTableData: Alert[];
  selectedOnCurrentPage: any[];
  getIsAlertSelected: (alertId: number) => boolean | undefined;
  toggleSelectRows: (
    newAlert: Alert,
    index: number,
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => void;
  handleSelectAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClickDismissAlerts: (alertToDismiss: Alert[]) => void;
}

export const ARCHIVED_ALERTS_TABLE_COLUMNS: Column<
  AlertOccurrenceActioned
>[] = [
  {
    Header: "Severity",
    id: "severity__id",
    accessor: data => data.severity_type_name
  },
  {
    Header: "Site",
    id: "alert__machine__site__name",
    accessor: data => data.site_name
  },
  {
    Header: "Machine",
    id: "alert__machine__name",
    accessor: data => data.machine_name
  },
  {
    Header: "Component",
    id: "alert__rule__tag__component__name",
    accessor: data => data.component_name
  },
  {
    Header: "Rule",
    id: "alert__rule__name",
    accessor: data => data.rule_name
  },
  {
    Header: "Action",
    id: "action",
    accessor: data => convertActionToString(data.action)
  },
  {
    Header: "Actioned On",
    id: "actioned_date",
    accessor: data => data.actioned_date,
    Cell: (cellProps: CellProps<AlertOccurrenceActioned>) => (
      <DateWithTooltip date={cellProps.value} />
    )
  },
  {
    Header: "Actioned By",
    id: "actioned_by__username",
    accessor: data => data.actioned_by_name,
    Cell: (cellProps: CellProps<AlertOccurrenceActioned>) =>
      AvatarCell({
        firstName: cellProps.row.original.actioned_by_first_name,
        lastName: cellProps.row.original.actioned_by_last_name
      })
  }
];
